import React, { useState, useEffect, useRef, useMemo } from "react";
import { Button } from "../../components/Button";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import { INSTRUCTIONS_VIDEOCHAT } from "../../constants/instructions";

import LocalVideoPreview from "../../components/ui/LocalVideoPreview";
import { NotificationBadge } from "../../components/notifications/NotificationBadge";

import DayLimit from "../../components/shared/DayLimit";
import GiftsShopModal from "../../components/gifts/GiftsShopModal";
import ChatProgressBar from "../../components/ui/ChatProgressBar";
import Match from "../Match";

import AgoraRTC from "agora-rtc-sdk-ng";
import config from "../../config";
import { axiosPrivate } from "../../axios";
import { AGORA_APP_ID } from "../../config";
import { useParams } from "react-router-dom";

// Иконки для кнопок
const MicOnIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
    <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
    <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
  </svg>
);

const MicOffIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
    <path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z" />
  </svg>
);

const CameraOnIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
    <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
  </svg>
);

const CameraOffIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
    <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z" />
  </svg>
);

const SwitchCameraIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
    <path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z" />
  </svg>
);

const EndCallIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
    <path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z" />
  </svg>
);

function VideoChat() {
  // const CHANNEL
  const { id } = useParams();
  const TOKEN = null; // Можно использовать токен, если требуется
  const CHANNEL = `videochat-${id}`; // Имя канала

  const [showToast, setShowToast] = useState(false);
  const [showInstruction, setShowInstruction] = useState(false);

  const [animateClass, setAnimateClass] = useState("animate-slideDown");

  const [menuAction, setMenuAction] = useState(2);

  const [dayLimit, setDayLimit] = useState(false);
  const [viewLimit, setViewLimit] = useState(false);
  const [presentsShop, setPresentsShop] = useState(false);

  const navigate = useNavigate();

  const [swipeStart, setSwipeStart] = useState(0);
  const presentsRef = useRef(null);

  const [screen, setScreen] = useState("start");
  //start, chatting, wait, match, out-of-limit,

  // Новые состояния для управления камерой и микрофоном
  const [isMuted, setIsMuted] = useState(false);
  const [isCameraOff, setIsCameraOff] = useState(false);
  const [currentCamera, setCurrentCamera] = useState("user"); // "user" или "environment"
  const [localVideoPosition, setLocalVideoPosition] = useState({
    top: 60,
    right: 20,
  });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const localAudioTrackRef = useRef(null);
  const localVideoTrackRef = useRef(null);

  const handleTouchStart = (e) => {
    setSwipeStart(e.touches[0].clientY);
  };

  const handleAddMytaCoins = async (amount) => {
    try {
      const response = await axiosPrivate.post(config.API.WALLET.PURCHASE, {
        amount,
        type: "mytaCoins",
      });
      console.log("Myta coins added:", response.data);
    } catch (error) {
      console.error("Error purchasing coins:", error);
    }
  };

  const handleTouchMove = (e) => {
    const swipeEnd = e.touches[0].clientY;
    const diff = swipeEnd - swipeStart;

    if (diff > 100) {
      setPresentsShop(false);
    }
  };

  const client = useMemo(
    () => AgoraRTC.createClient({ mode: "rtc", codec: "vp8" }),
    []
  );

  const remoteVideoRef = useRef(null);

  // Функция для переключения микрофона
  const toggleMute = async () => {
    if (localAudioTrackRef.current) {
      await localAudioTrackRef.current.setEnabled(!isMuted);
      setIsMuted(!isMuted);
    }
  };

  // Функция для переключения камеры
  const toggleCamera = async () => {
    if (localVideoTrackRef.current) {
      await localVideoTrackRef.current.setEnabled(!isCameraOff);
      setIsCameraOff(!isCameraOff);
    }
  };

  // Функция для переключения фронтальной/задней камеры
  const switchCamera = async () => {
    if (localVideoTrackRef.current) {
      const newFacingMode = currentCamera === "user" ? "environment" : "user";

      try {
        // Останавливаем текущий трек
        localVideoTrackRef.current.stop();
        localVideoTrackRef.current.close();

        // Создаем новый трек с другой камерой
        const newVideoTrack = await AgoraRTC.createCameraVideoTrack({
          facingMode: newFacingMode,
        });

        localVideoTrackRef.current = newVideoTrack;

        // Воспроизводим на локальном видео
        newVideoTrack.play("local-video");

        // Публикуем новый трек
        await client.unpublish();
        await client.publish([localAudioTrackRef.current, newVideoTrack]);

        setCurrentCamera(newFacingMode);
      } catch (error) {
        console.error("Error switching camera:", error);
      }
    }
  };

  // Функция завершения звонка
  const endCall = async () => {
    if (localAudioTrackRef.current) {
      localAudioTrackRef.current.stop();
      localAudioTrackRef.current.close();
    }
    if (localVideoTrackRef.current) {
      localVideoTrackRef.current.stop();
      localVideoTrackRef.current.close();
    }
    await client.leave();
    navigate("/video-chat-roulette");
  };

  // Обработка перетаскивания локального видео
  const handleDragStart = (e) => {
    setIsDragging(true);
    const touch = e.type === "touchstart" ? e.touches[0] : e;
    setDragStart({
      x: touch.clientX - localVideoPosition.right,
      y: touch.clientY - localVideoPosition.top,
    });
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;

    const touch = e.type === "touchmove" ? e.touches[0] : e;
    const newRight = touch.clientX - dragStart.x;
    const newTop = touch.clientY - dragStart.y;

    // Ограничения экрана
    const maxRight = window.innerWidth - 120;
    const maxTop = window.innerHeight - 200;

    setLocalVideoPosition({
      right: Math.max(10, Math.min(newRight, maxRight)),
      top: Math.max(60, Math.min(newTop, maxTop)),
    });
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    const initAgora = async () => {
      try {
        // Подключение к каналу (uid = null означает, что Agora выдаст случайный uid)
        const uid = await client.join(AGORA_APP_ID, CHANNEL, TOKEN, null);

        // Создание локального видеотрека
        const [localAudioTrack, localVideoTrack] =
          await AgoraRTC.createMicrophoneAndCameraTracks({
            videoConfig: {
              facingMode: currentCamera,
            },
          });

        localAudioTrackRef.current = localAudioTrack;
        localVideoTrackRef.current = localVideoTrack;

        // Вывод локального видео
        localVideoTrack.play("local-video");

        // Публикация аудио- и видео-треков в канал
        await client.publish([localAudioTrack, localVideoTrack]);

        console.log(`User ${uid} joined the channel`);

        client.remoteUsers.forEach(async (user) => {
          if (user.hasVideo) {
            // Проверяем, есть ли видео
            await client.subscribe(user, "video");
            user.videoTrack.play("remote-video");
          }
          if (user.hasAudio) {
            // Проверяем, есть ли аудио
            await client.subscribe(user, "audio");
            user.audioTrack.play();
          }
        });

        // client.on("user-joined", async (user) => {
        //     console.log(`User ${user.uid} joined`);
        //     await subscribeToUser(user);
        // });

        // Обработчик для отображения входящих видео от других пользователей
        client.on("user-published", async (user, mediaType) => {
          await client.subscribe(user, mediaType);
          if (mediaType === "video") {
            const remoteVideoTrack = user.videoTrack;
            // const remotePlayerContainer = document.createElement("div");
            // remotePlayerContainer.id = `player-${user.uid}`;
            // remotePlayerContainer.style.width = "640px";
            // remotePlayerContainer.style.height = "480px";
            // document.body.append(remotePlayerContainer);

            const remotePlayerContainer =
              document.getElementById("remote-video");
            // console.log(remotePlayerContainer);
            // remoteVideoTrack.play(remotePlayerContainer);
            if (remotePlayerContainer) {
              remoteVideoTrack.play(remotePlayerContainer);
            } else {
              console.error("Remote video container not found");
            }
          }
          if (mediaType === "audio") {
            const remoteAudioTrack = user.audioTrack;
            remoteAudioTrack.play(); // Включает звук
          }
        });

        // Удаление видео, если пользователь выходит
        client.on("user-unpublished", (user) => {
          const remotePlayerContainer = document.getElementById("remote-video");
          if (remotePlayerContainer) {
            remotePlayerContainer.remove();
          }
        });
      } catch (error) {
        console.error("Agora Error: ", error);
      }
    };

    initAgora();

    return () => {
      client.leave();
    };
  }, [client]);

  const subscribeToUser = async (user) => {
    if (user.hasVideo) {
      await client.subscribe(user, "video");
      user.videoTrack.play("remote-video");
    }
    if (user.hasAudio) {
      await client.subscribe(user, "audio");
      user.audioTrack.play();
    }
  };

  useEffect(() => {
    const isFirstVisitChat = localStorage.getItem("firstVisitChat2");
    // const isFirstVisitChat = false;
    if (!isFirstVisitChat) {
      console.log("Пользователь нажал OK");
      setShowInstruction(true);
      setShowToast(true);
      setAnimateClass("animate-slideDown");
      setTimeout(() => {
        setAnimateClass("animate-slideUp");
        // После окончания анимации скрытия (1 секунда), убираем тост из DOM
        setTimeout(() => {
          setShowToast(false);
        }, 1000);
      }, 8000);

      localStorage.setItem("firstVisitChat2", "true");
    }
  }, []);

  return (
    <>
      {showInstruction && (
        <div
          className={`z-[9999] w-[100vw] h-[100vh] fixed top-0 left-0 flex flex-col bg-black/80 backdrop-blur-[10px]`}
          style={{ touchAction: "pan-y" }}
        >
          <div className="flex-1 overflow-y-auto pt-[60px] pb-[140px] flex justify-start items-center flex-col">
            <h1 className="font-raleway font-bold text-white text-[26px]">
              Инструкция
            </h1>
            <h1 className="font-raleway font-light mt-2 text-white text-center text-[18px]">
              Основные функции и жесты
            </h1>
            <div className="grid grid-cols-1 justify-center flex-wrap items-center gap-[16px] mt-[16px] px-4">
              {INSTRUCTIONS_VIDEOCHAT.map((ins, index) => (
                <div
                  key={ins.id}
                  className={`w-[343px] pt-[10px] pb-[10px] gap-[12px] border-b ${
                    index === INSTRUCTIONS_VIDEOCHAT.length - 1
                      ? "border-none"
                      : "border-[#6D6D6D]"
                  } flex text-white`}
                >
                  <div className="h-[89px] flex justify-center items-center">
                    <img
                      src={ins.svg}
                      className="w-[40px] h-[40px]"
                      alt={ins.title}
                    />
                  </div>
                  <div className={`flex flex-col gap-[4px]`}>
                    <span className={`w-[270px] text-[18px] font-semibold`}>
                      {ins.title}
                    </span>
                    <span className={`w-[268px] text-[14px] font-light`}>
                      {ins.description}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="fixed bottom-[40px] left-0 right-0 flex justify-center z-[10000] pointer-events-none">
            <div className="pointer-events-auto">
              <Button onClick={() => setShowInstruction(false)}>Понятно</Button>
            </div>
          </div>
        </div>
      )}

      {/* Полноэкранный режим видеозвонка */}
      {screen === "chatting" && (
        <div className="fixed inset-0 w-full h-full bg-black z-50 border-4 border-red-500">
          <div className="relative w-full h-full border-4 border-blue-500">
            {/* Удаленное видео на весь экран */}
            <div
              id="remote-video"
              ref={remoteVideoRef}
              className="absolute inset-0 w-full h-full object-cover bg-gray-900 border-4 border-green-500"
            ></div>

            {/* Индикатор активного звонка */}
            <div className="absolute top-8 left-1/2 transform -translate-x-1/2 z-10 flex items-center gap-2 px-4 py-2 rounded-full bg-black/50 backdrop-blur-md">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
              <span className="text-white text-sm font-medium">00:25</span>
            </div>

            {/* Прогресс бар вверху */}
            <div className="absolute top-20 left-0 right-0 z-10 flex items-center justify-center">
              <ChatProgressBar completed={25} />
            </div>

            {/* Локальное видео (перемещаемое) */}
            <div
              id="local-video"
              onMouseDown={handleDragStart}
              onMouseMove={handleDragMove}
              onMouseUp={handleDragEnd}
              onTouchStart={handleDragStart}
              onTouchMove={handleDragMove}
              onTouchEnd={handleDragEnd}
              style={{
                position: "absolute",
                top: `${localVideoPosition.top}px`,
                right: `${localVideoPosition.right}px`,
                zIndex: 20,
                width: "120px",
                height: "180px",
                borderRadius: "16px",
                overflow: "hidden",
                border: "3px solid rgba(255, 255, 255, 0.3)",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
                cursor: isDragging ? "grabbing" : "grab",
                transform:
                  currentCamera === "user" ? "scaleX(-1)" : "scaleX(1)",
              }}
            ></div>

            {/* Кнопки управления внизу в стиле FaceTime */}
            <div className="absolute bottom-0 left-0 right-0 z-30 pb-8 flex items-center justify-center">
              <div className="flex items-center justify-center gap-6 px-6 py-4 rounded-full bg-black/40 backdrop-blur-md">
                {/* Кнопка переключения камеры */}
                <button
                  onClick={switchCamera}
                  className="w-14 h-14 rounded-full bg-gray-700/80 hover:bg-gray-600/80 flex items-center justify-center transition-all active:scale-95"
                >
                  <SwitchCameraIcon />
                </button>

                {/* Кнопка микрофона */}
                <button
                  onClick={toggleMute}
                  className={`w-14 h-14 rounded-full flex items-center justify-center transition-all active:scale-95 ${
                    isMuted
                      ? "bg-red-500 hover:bg-red-600"
                      : "bg-gray-700/80 hover:bg-gray-600/80"
                  }`}
                >
                  {isMuted ? <MicOffIcon /> : <MicOnIcon />}
                </button>

                {/* Кнопка завершения звонка */}
                <button
                  onClick={endCall}
                  className="w-16 h-16 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center transition-all active:scale-95 shadow-lg"
                >
                  <EndCallIcon />
                </button>

                {/* Кнопка камеры */}
                <button
                  onClick={toggleCamera}
                  className={`w-14 h-14 rounded-full flex items-center justify-center transition-all active:scale-95 ${
                    isCameraOff
                      ? "bg-red-500 hover:bg-red-600"
                      : "bg-gray-700/80 hover:bg-gray-600/80"
                  }`}
                >
                  {isCameraOff ? <CameraOffIcon /> : <CameraOnIcon />}
                </button>

                {/* Кнопка подарка */}
                <button
                  onClick={() => setPresentsShop(true)}
                  className="w-14 h-14 rounded-full bg-gray-700/80 hover:bg-gray-600/80 flex items-center justify-center transition-all active:scale-95"
                >
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                    <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Обычный режим */}
      {screen !== "chatting" && (
        <div className="w-full h-screen pt-8 flex flex-col items-center overflow-hidden border-4 border-yellow-500">
          {/* Верхняя панель */}
          <div className="z-10 w-full flex justify-center items-center flex-col">
            <div className="w-[343px] flex flex-row">
              <img
                src="/icons/Button-menu.svg"
                className="mt-3 w-[44px] h-[44px]"
                onClick={() => navigate("/profileMenu")}
              />
              <div className="flex flex-row justify-end flex-grow">
                <img
                  src="/icons/Button-instruction.svg"
                  className="mt-3 ml-3 w-[44px] h-[44px] cursor-pointer"
                  onClick={() => setShowInstruction(true)}
                />

                <div className="relative mt-3 ml-3">
                  <img
                    src="/icons/Button-notifications.svg"
                    className="w-[44px] h-[44px] cursor-pointer"
                    onClick={() => {
                      navigate("/notifications");
                    }}
                  />
                  <NotificationBadge />
                </div>
              </div>
            </div>
          </div>

          <div className="z-0 w-full flex justify-center items-center flex-col">
            <div></div>
            <div className="w-full flex justify-center items-center mt-4">
              {screen === "limit" && (
                <div
                  className="w-[343px] h-[527px]
                            bg-[#043939] rounded-[16px]
                            flex items-center justify-center flex-col
                            "
                >
                  <img src="/icons/ViewLimit.svg" alt="" />
                  <p className="text-center text-white text-[22px] font-semibold mt-2">
                    Просмотры закончились
                    <br />
                    (40/40)
                  </p>
                  <p className="text-center text-white text-[16px] font-normal mt-2">
                    Новые будут доступны через:
                  </p>
                  <div className="mt-5 rounded-[8px] text-white bg-[#0B6666] pl-[12px] pr-[12px] pt-[8px] pb-[8px]">
                    23 ч 59 мин
                  </div>
                  <div className="mt-8">
                    <Button className="w-[300px]">
                      Хочу 600 просмотров в день
                    </Button>
                  </div>
                </div>
              )}
              {screen === "wait" && (
                <div
                  className="w-[343px] h-[527px]
                        bg-[#043939] rounded-[16px]
                        flex items-center justify-center flex-col
                        "
                >
                  <object
                    data="/icons/video_chat_wait.svg"
                    type="image/svg+xml"
                    className="w-[48px] h-[48px]"
                  ></object>
                  <p className="text-center text-white text-[20px] font-medium mt-[19px]">
                    Ищем собеседника.
                  </p>
                  <p className="text-center text-white text-[20px] font-medium">
                    Пожалуйста подождите...
                  </p>
                  <div className="w-[100%]"></div>
                </div>
              )}
              {screen === "start" && (
                <div className="relative w-[343px] h-[527px] bg-[#043939] rounded-[16px] flex items-center justify-center flex-col overflow-hidden">
                  {/* Кнопка переключения камеры на превью */}
                  <button
                    onClick={() => {
                      // Здесь можно добавить логику переключения для превью
                      setCurrentCamera(
                        currentCamera === "user" ? "environment" : "user"
                      );
                    }}
                    className="absolute top-4 right-4 z-20 w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm hover:bg-black/70 flex items-center justify-center transition-all active:scale-95"
                  >
                    <SwitchCameraIcon />
                  </button>

                  <div className="absolute z-10 bottom-16 w-[311px] flex items-center justify-center">
                    <Button onClick={() => setScreen("chatting")}>
                      Найти собеседника
                    </Button>
                  </div>

                  <div className="w-full h-full">
                    <LocalVideoPreview
                      screen={screen}
                      style={{
                        zIndex: 2,
                        width: "100%",
                        height: "100%",
                        borderRadius: "12px",
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Навигация */}
         
        </div>
      )}

      {/* Тосты и модалки - показываются поверх всего */}
      {showToast && handleAddMytaCoins(25) && (
        <div
          className={`z-[150] w-[343px] fixed font-light mt-2  text-white flex justify-center items-center flex-wrap font-raleway gap-[5px] text-[16px] px-4 py-2 rounded-lg bg-[#043939] border-[1.5px] border-[#a1f69e] cursor-pointer ${animateClass}`}
          onClick={() => {
            setAnimateClass("animate-slideUp");
            setTimeout(() => {
              setShowToast(false);
            }, 500);
          }}
        >
          Вам начислено: <span className="text-[18px] font-medium">+25</span>{" "}
          <img src="/icons/myta-coin.svg" alt="" />
        </div>
      )}
      {dayLimit && (
        <div
          className="fixed inset-0  bg-opacity-50 flex justify-center items-end z-20"
          onClick={() => {
            setDayLimit(false);
          }}
        >
          <div
            className="w-full rounded-t-2xl transform transition-transform duration-300 translate-y-0"
            onClick={(e) => e.stopPropagation()}
          >
            <DayLimit type="like" onClose={() => setDayLimit(false)} />
          </div>
        </div>
      )}
      {presentsShop && (
        <div
          className="fixed inset-0 bg-opacity-50 flex justify-center items-end z-20 bg-black/80 backdrop-blur-[10px]"
          onClick={() => {
            setPresentsShop(false);
          }}
        >
          <div
            className="w-full rounded-t-2xl transform transition-transform duration-300 translate-y-0"
            onClick={(e) => e.stopPropagation()}
            ref={presentsRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            <GiftsShopModal />
          </div>
        </div>
      )}
    </>
  );
}

export default VideoChat;
